module.exports = __webpack_public_path__ + "img/A1-topImg-m.0361c840.png";